module.exports = "<p>\n  <input #query (keyup)=\"filter(query.value)\" type=\"text\" class=\"form-control\">\n</p>"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/search-bar/search-bar.component.html
// module id = ../../../../../src/app/search-bar/search-bar.component.html
// module chunks = main